import React, { useState, useRef, useEffect } from 'react';
import { Navbar, Nav, Container, Dropdown } from 'react-bootstrap';
import MyDropdown from "./Dropdown"
import { ModalContext, ModalProvider, ModalRoot } from 'react-multi-modal';
import { connect } from "react-redux";
import axios from 'axios';
import { baseURL } from '../helpers/baseURL';
import * as actionCreators from "../redux/actions/index"
import { withRouter, useHistory } from "react-router-dom";
import { IoNotificationsOutline } from "react-icons/io5";
import showsysLight from "../../css/img/show_sys_logo.svg"
import showsysDark from "../../css/img/show_sys_logo-dark.svg"
import sendbat from "../../css/img/sendbat.svg"
import tools from "../../css/img/tools.svg"
import { IoSearchOutline } from "react-icons/io5";
import arrow from "../../css/img/arrow-down-color.svg"
import { useSelector, useDispatch } from 'react-redux';
import { fetchUser, fetchNotificationTicket } from '../redux/actions/index';
import GlobalSearch from "./GlobalSearch/GlobalSearch";
import "./navbar.css"
// modals
import Notification from "./Pages/Notification";
import NotificationCenter from "./Pages/NotificationCenter";
import 'react-confirm-alert/src/react-confirm-alert.css';
import Cookies from "js-cookie";
import { FiPhoneCall } from "react-icons/fi";
import { ImExit } from "react-icons/im";
import { confirmAlert } from 'react-confirm-alert'
import { HiOutlineCog } from "react-icons/hi";

const ListPlatformsStatic = [
    {
        name: 'CRM',
        description: 'Customer Relationship Management',
        icon: '/images/platforms/crm.svg',
        youtube: 'https://www.youtube.com/watch?v=T-I4HYCz9yE'
    },
    {
        name: 'Sendbat',
        description: 'SMS and Email Automation',
        icon: '/images/platforms/sendbat.svg',
        youtube: 'https://www.youtube.com/watch?v=zYasXlSmyKI'
    },
    {
        name: 'Urless',
        description: 'Short URL & QR Code Generator',
        icon: '/images/platforms/urless.svg',
        youtube: null
    },
    {
        name: 'Morsix',
        description: 'Inventory Management',
        icon: '/images/platforms/morsix.svg',
        youtube: 'https://www.youtube.com/watch?v=OEImRnCyFM0'
    },
    {
        name: 'Claritask',
        description: 'Project Management',
        icon: '/images/platforms/claritask.svg',
        youtube: 'https://www.youtube.com/watch?v=4cJ25YK9W6k'
    },
    {
        name: 'Claritick',
        description: 'Ticketing System',
        icon: '/images/platforms/claritick.svg',
        youtube: 'https://www.youtube.com/watch?v=xITyoLiGEb4'
    },
    /* {
        name: 'Convosio',
        description: 'Chat System',
        icon: '/images/platforms/convosio.svg',
        youtube: 'https://www.youtube.com/watch?v=fw5Xz3h9Clg'
    }, */
    {
        name: 'Zuitte',
        description: 'Business Solution',
        icon: '/images/platforms/zuitte.svg',
        youtube: null
    },
    {
        name: 'Ipaymer',
        description: 'Payment Processing System',
        icon: '/images/platforms/ipaymer.svg',
        youtube: null
    },
    {
        name: 'Azalytics',
        description: 'Web Analytics',
        icon: '/images/platforms/azalytics.svg',
        youtube: null
    },
];



const NavBar = ({ isLogged, collapsed, theme }) => {
    const dispatch = useDispatch()
    const [navbarState, setNavbarState] = useState({
        dropdown: false,
        sys: false,
        showOnMob: false,
    })
    const [workspaceInfo, setWorkspaceInfo] = useState({
        balance: 0,
        storage: {
            size: "0 B",
            used: "0 B",
            available: "0 B",
        },
        creditsError: null,
        storageError: null,
        loading: false,
    });
    const sysRef = useRef();
    const navRef = useRef();
    const toolsRef = useRef();
    const history = useHistory();

    const [searchOpen, setSearchOpen] = useState(false);
    const user = useSelector(state => state.userReducer.user)
    const new_tickets = useSelector(state => state.newTickets.new_tickets)

    useEffect(() => {
        const onLockedPage = window.location.pathname.startsWith('/workspace/locked');

        if (!isLogged || onLockedPage || user?.workspace_locked) {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }

        dispatch(fetchUser())
        dispatch(fetchNotificationTicket());
        const timer = setTimeout(() => {
            loadWorkspaceInfo();
        }, 300);

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            clearTimeout(timer);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isLogged, user?.workspace_locked]);

    // Ctrl+K / Cmd+K opens global search from anywhere in the app.
    useEffect(() => {
        if (!isLogged) {
            return;
        }

        const onKeyDown = (event) => {
            if ((event.ctrlKey || event.metaKey) && String(event.key).toLowerCase() === 'k') {
                event.preventDefault();
                setSearchOpen(true);
            }
        };

        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [isLogged]);

    useEffect(() => {
        // .dropdown-open
        if (navbarState.sys) {
            document.body.classList.add('dropdown-open');
        } else {
            document.body.classList.remove('dropdown-open');
        }
    }, [navbarState?.sys]);

    const handleClickOutside = (event) => {
        if (sysRef.current && !sysRef.current.contains(event.target)) {
            setNavbarState(prev => ({ ...prev, sys: false }));
        }

        if (
            navRef.current &&
            !navRef.current.contains(event.target) &&
            toolsRef.current &&
            !toolsRef.current.contains(event.target)
        ) {
            setNavbarState(prev => ({ ...prev, showOnMob: false }));
        }
    };

    const openSearch = () => setSearchOpen(true);

    const loadWorkspaceInfo = async () => {
        if (user?.workspace_locked || window.location.pathname.startsWith('/workspace/locked')) {
            return;
        }

        try {
            setWorkspaceInfo(prev => ({
                ...prev,
                loading: true
            }));

            const authHeaders = {
                headers: {
                    Authorization: `Bearer ${Cookies.get('access_token')}`
                }
            };

            const [creditsRes, storageRes] = await Promise.all([
                axios.get(`${baseURL}credits`, authHeaders),
                axios.get(`${baseURL}storage`, authHeaders)
            ]);

            setWorkspaceInfo({
                balance: creditsRes?.data?.balance ?? 0,
                storage: storageRes?.data?.storage ?? {
                    size: "0 B",
                    used: "0 B",
                    available: "0 B"
                },
                creditsError: creditsRes?.data?.success === false ? creditsRes?.data?.message : null,
                storageError: storageRes?.data?.success === false ? storageRes?.data?.message : null,
                loading: false
            });
        } catch (error) {
            console.error("Failed to load workspace info:", error);
            setWorkspaceInfo(prev => ({
                ...prev,
                loading: false,
                creditsError: prev.creditsError ?? "Failed to load credits.",
                storageError: prev.storageError ?? "Failed to load storage.",
            }));
        }
    };

    const Logout = async () => {
            confirmAlert({
                title: 'Are you sure you want to logout?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () =>
                            axios.post(`${baseURL}logout`, {}, {
                                headers: {
                                    Authorization: `Bearer ${Cookies.get('access_token')}`
                                }
                            })
                                .catch(error => console.error(error))
                                .finally(() => {
                                    localStorage.clear();
                                    Cookies.remove('access_token');
                                    Cookies.remove('mydev_token');
                                    history.push('/');
                                })
                    },
                    {
                        label: 'No'
                    }
                ],
                overlayClassName: "confirm-overlay"
            });
        };

    const availableCredit = Number(workspaceInfo?.balance ?? 0).toFixed(2);
    const availableStorage = workspaceInfo?.storage?.available ?? "0 B";


    const isDarkTheme = theme === 'dark';

    return (
        <>
            <GlobalSearch show={searchOpen} onClose={() => setSearchOpen(false)} />
            <span
                ref={toolsRef}
                className="toggleTools"
                onClick={(e) => {
                    e.stopPropagation();
                    setNavbarState(prev => ({
                        ...prev,
                        showOnMob: !prev.showOnMob
                    }));
                }}
            >
                <HiOutlineCog />
            </span>

            <div
                className={`navbar-shell ${collapsed ? "collapsed" : ""} ${navbarState.showOnMob ? "showOnMob" : ""}`}
                ref={navRef}
            >
                <div className="topbar">
                    <div className="topbar-left"></div>

                    <div className="topbar-right">
                        <span className="topbar-item">
                            <span className="topbar-label">Storage:</span>
                            <span className="topbar-value">{availableStorage}</span>
                        </span>

                        <span className="topbar-item">
                            <span className="topbar-label">Available Credit:</span>
                            <span className="topbar-value">${availableCredit}</span>
                        </span>

                        <button type="button" className="topbar-item topbar-item-icon topbar-action">
                            <FiPhoneCall />
                            <span className="topbar-value">Phone Connect</span>
                        </button>

                        <button 
                            type="button"
                            className="topbar-item topbar-item-icon topbar-action"
                            onClick={Logout}>
                            <ImExit />
                                    {/* <img src={logout} alt="logout" /> */}
                                    <span className="topbar-value">Log Out</span>
                        </button>
                    </div>
                </div>

                <div className="navbar-main">
                    <div className="navbar-main-left">
                        {/* Opens the global search palette; the real input lives there. */}
                        <button
                            type="button"
                            className="navbar-search navbar-search-trigger"
                            onClick={openSearch}
                            aria-label="Search"
                        >
                            <span className="navbar-search-icon">
                                <IoSearchOutline className="navbar-search-icon-svg" />
                            </span>
                            <span className="navbar-search-trigger-label">Search</span>
                        </button>
                    </div>

                    <div className="navbar-main-right">
                        <Dropdown
                            className="systems-holder-dropdown"
                            show={navbarState.sys}
                            onClick={() =>
                                setNavbarState(prev => ({
                                    ...prev,
                                    sys: !prev.sys
                                }))
                            }
                            ref={sysRef}
                        >
                            <Dropdown.Toggle className="dropdown-profile">
                                <img src={isDarkTheme ? showsysDark : showsysLight} alt="systems" className="toggle-systems-icon" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="sys-ticketing-body">
                                <div className="switch-dropdown-holder">
                                    <div className="title-platform-dropdown">
                                        Platforms
                                    </div>

                                    {ListPlatformsStatic.map((platform, index) => {
                                        return (
                                            <a
                                                key={index}
                                                target="_blank"
                                                rel="noreferrer"
                                                href={platform?.youtube ?? '#'}
                                                style={{
                                                    "--platform-straggle-multiplayer": index
                                                }}
                                                className="platform-holder-icon access_accept"
                                            >
                                                <img src={platform?.icon} alt={platform?.name} />
                                                <div className="flex-grow-1 ps-2">
                                                    <div className="title">{platform?.name}</div>
                                                    <p className="paragraph">
                                                        {platform?.description}
                                                    </p>
                                                </div>
                                                <img
                                                    src="/images/platforms/logo-youtube.svg"
                                                    alt="youtube"
                                                    className="platform-holder-icon-youtube"
                                                />
                                            </a>
                                        )
                                    })}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>

                        <NotificationsBar />
                    </div>
                </div>
            </div>
        </>
    );

}


function NotificationsBar() {
    const userSelector = useSelector(state => state.userReducer.user);
    const isMountedRef = useRef(false);

    const [notificationsCounts, setNotificationsCounts] = useState({
        allNotificationsCount: 0,
        unReadNotificationsCount: 0
    });

    useEffect(() => {
        isMountedRef.current = true;

        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        let currentWorkspaceId = userSelector?.current_workspace;
        if (!currentWorkspaceId || !userSelector?.id) return;

        window.Echo
            .private('user.' + userSelector.id)
            .listen('.Notification', handleListenSocket);

        return () => {
            window.Echo.leave('user.' + userSelector.id);
        };
    }, [userSelector?.current_workspace, userSelector?.id]);

    useEffect(() => {
        handleFetchNotificationsCount();
    }, []);

    const showModalNotify = (showModal) => {
        showModal({
            component: NotificationCenter,
            modalProps: {
                handleFetchNotificationsCount
            }
        });
    };

    function handleListenSocket() {
        if (!isMountedRef.current) return;

        setNotificationsCounts(prev => ({
            allNotificationsCount: prev.allNotificationsCount + 1,
            unReadNotificationsCount: prev.unReadNotificationsCount + 1
        }));
    }

    function handleFetchNotificationsCount() {
        fetchNotifications({ countOnly: true })
            .then((data) => {
                if (isMountedRef.current) {
                    setNotificationsCounts(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    return <>
        <ModalProvider>
            <ModalContext.Consumer>
                {({ showModal, hideModal }) => (
                    <>
                        <div className="position-relative notification-header-panel" onClick={() => showModalNotify(showModal)}>
                            <IoNotificationsOutline className="notification-icon" />
                            {notificationsCounts?.unReadNotificationsCount > 0 && <span className='svgColor'>{notificationsCounts?.unReadNotificationsCount}</span>}
                        </div>
                        <ModalRoot />
                    </>
                )}
            </ModalContext.Consumer>
        </ModalProvider>
    </>
}


async function fetchNotifications({ countOnly = false }) {
    const param = new URLSearchParams();
    countOnly && param.append("countOnly", true);
    const response = await axios.get("/api/notifications?" + param.toString(), {
        headers: {
            'Authorization': 'Bearer ' + Cookies.get('access_token')
        }
    });
    return response.data;
}


export default NavBar